import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class UserPortfolioProfileResultDto extends UserNameDisplayResultDto {
    email: string;
    phone: string;
    title: string;
    profileImageUrl: string;
}
